/**
 * Injects Cloudinary parameters into the URL to serve a compressed, resized thumbnail.
 * q_auto = Automatic quality compression
 * f_auto = Automatically serves WebP or AVIF instead of heavy JPEGs
 * c_limit,w_{width} = Resizes the image so it's never larger than the container
 */
export const getOptimizedUrl = (url, width = 400) => {
    if (!url || !url.includes('cloudinary.com')) return url;

    // Intercept the URL and inject the optimization parameters right after '/upload/'
    return url.replace('/upload/', `/upload/c_limit,w_${width},q_auto,f_auto/`);
};
